<ion-row>
  <ion-col size="12" size-md>
    <div class="phi-flex-wrap-center phi-gap-12">
      <ion-searchbar class="global-ion-search-box mw-sm-225" [debounce]="600" (ionInput)="onSearchFilter($event)"></ion-searchbar>
      <ng-multiselect-dropdown class="w-100 mw-sm-auto" [placeholder]="'Grievance Type'" [settings]="dropdownSettings" [data]="getLocationList" [(ngModel)]="selectedGrievance" (onSelect)="onGrievanceType()" (onDeSelect)="onGrievanceType()">
      </ng-multiselect-dropdown>
    </div>
  </ion-col>
  <ion-col size="12" size-md="auto">
    <div class="phi-flex-wrap-center phi-gap-12 phi-justify-content-end">
      <label class="phi-flex phi-gap-6 phi-align-items-center">
        <ion-label class="fs-14 fs_12ForMobile font_regular">Show</ion-label>
        <mat-form-field class="w-100 max-w-75 mat-height40 mat-input-style">
          <mat-select placeholder="Select" placeholder="Select" (selectionChange)="onDislaySelectedRecord($event)" [value]="25">
            <mat-option [value]="25">25</mat-option>
            <mat-option [value]="50">50</mat-option>
            <mat-option [value]="75">75</mat-option>
            <mat-option [value]="100">100</mat-option>
          </mat-select>
        </mat-form-field>
        <ion-label class="fs-14 fs_12ForMobile font_regular">entries</ion-label>
      </label>
      <div>
        <span class="icon-download fs-20 material-icons" (click)="downloadCSV()">download</span>
      </div>
    </div>
  </ion-col>
</ion-row>


<div class="table-container mt-10 mb-10">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.srNo.showInTable">
          {{ tableheadersAndData.tableHeaders.srNo.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.grievanceType.showInTable">
          {{ tableheadersAndData.tableHeaders.grievanceType.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.againstWhom.showInTable">
          {{ tableheadersAndData.tableHeaders.againstWhom.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.whomToSent.showInTable">
          {{ tableheadersAndData.tableHeaders.whomToSent.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.raisedDate.showInTable">
          {{ tableheadersAndData.tableHeaders.raisedDate.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.priority.showInTable">
          {{ tableheadersAndData.tableHeaders.priority.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.reason.showInTable">
          {{ tableheadersAndData.tableHeaders.reason.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.commentFromReceiver.showInTable">
          {{ tableheadersAndData.tableHeaders.commentFromReceiver.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.status.showInTable">
          {{ tableheadersAndData.tableHeaders.status.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.resolvedDate.showInTable">
          {{ tableheadersAndData.tableHeaders.resolvedDate.name }}
        </th>
        <th class="fs-14 fs_12ForMobile font_bold" *ngIf="tableheadersAndData.tableHeaders.editDelete.showInTable">
          {{ tableheadersAndData.tableHeaders.editDelete.name }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let tableData of tableData; let i = index;">
        <td class="text-center">{{ i + 1 }}</td>
        
        <td *ngIf="tableheadersAndData.tableHeaders.grievanceType.showInTable">{{ tableData.grievanceType }}</td>
        <td *ngIf="tableheadersAndData.tableHeaders.againstWhom.showInTable">{{ tableData.againstWhom }}</td>
        <td *ngIf="tableheadersAndData.tableHeaders.whomToSent.showInTable">{{ tableData.whomToSent }}</td>
        <td *ngIf="tableheadersAndData.tableHeaders.raisedDate.showInTable">{{ tableData.raisedDate | date: 'dd-MM-yyyy' }}</td>
        <td *ngIf="tableheadersAndData.tableHeaders.priority.showInTable">{{ tableData.priority }}</td>
        
        <td *ngIf="tableheadersAndData.tableHeaders.reason.showInTable">
          <textarea rows="3" cols="32" class="edittextarea" [readonly]="tableData.status === 'Resolved' || isEditData !== i" name="reason" [disabled]="tableData.tabType">{{ tableData.reason }}</textarea>
        </td>
        <td *ngIf="tableheadersAndData.tableHeaders.commentFromReceiver.showInTable">
          <textarea rows="3" cols="32" class="edittextarea" [readonly]="tableData.status === 'Resolved' || isEditData !== i" name="commentFromReceiver">{{ tableData.commentFromReceiver }}</textarea>
        </td>
        
        <td *ngIf="tableheadersAndData.tableHeaders.status.showInTable">{{ tableData.status }}</td>
        <td *ngIf="tableheadersAndData.tableHeaders.resolvedDate.showInTable">{{ tableData.resolvedDate | date:'dd-MM-yyyy' }}</td>
        
        <td *ngIf="tableheadersAndData.tableHeaders.editDelete.showInTable">
          <div class="table-row-actions" *ngIf="tableData.status != 'Resolved'">
            <mat-icon class="material-symbols-outlined yellow" *ngIf="tableData.tabType == 'allGrievance' ? !(tableData.ifStatusClosed || tableData.ifStatusInProgress): !(tableData.ifStatusClosed)" (click)="onEditGrievance(tableData.tabType, tableData.id)">edit_square</mat-icon>
            <mat-icon class="material-icons red-cl" *ngIf="tableData.tabType == 'allGrievance' && !(tableData.ifStatusClosed || tableData.ifStatusInProgress || tableData.ifComment)" (click)="deleteData(tableData.id)">delete</mat-icon>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>




<!-- <div>showing result and pagenation</div> -->